const returnFormatData = (item) => item?.format || item || {};

export const getPrimaryCategory = (categories) => (categories || []).find((item) => returnFormatData(item).is_primary);

export const getBreadcrumbs = (categories = []) => {
    const primaryCategory = getPrimaryCategory(categories);
    if (!primaryCategory) {
        return [];
    }
    return (categories || []).filter(
        (c) => returnFormatData(c).root_code === primaryCategory.code && returnFormatData(c).permalink,
    );
};

export const productBreadcrumbs = (categories = []) => {
    return getBreadcrumbs(categories).map((category) => {
        return {
            code: category.code,
            permalink: returnFormatData(category).permalink,
            title: returnFormatData(category).name,
        };
    });
};

export const formattedUrl = (categories = [], uniqueName, t) => {
    try {
        const prefix = t ? t("general.products") : "/produkter";
        const bredcrumbs = getBreadcrumbs(categories);
        const sortedBreadcrumbs = bredcrumbs.sort((a, b) => returnFormatData(b).level - returnFormatData(a).level);
        const baseUrl = returnFormatData(sortedBreadcrumbs[0]).permalink || "/produkt";

        return `${baseUrl}/${prefix}/${uniqueName}`.toLowerCase();
    } catch (error) {
        return "";
    }
};

export const getParametric = (code, product = {}) => {
    const parametrics = product.parametrics || [];
    const variantParametrics = product.variant_parametrics || [];

    const findParametric = (parametric) => {
        if (Array.isArray(code)) {
            return code.indexOf(parametric.code) !== -1 && parametric?.value?.length > 0;
        }
        return parametric.value?.length > 0 && parametric.code === code;
    };

    return parametrics.find(findParametric) || variantParametrics.find(findParametric);
};
